module.exports = __webpack_public_path__ + "img/breadcrumbs-notes.c771d000.jpg";